import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import SecondaryButton from "shared/components/inputs/button/SecondaryButton";
import Table from "shared/components/data-display/tables/Table";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import VStack from "shared/components/layout/stack/VStack";
import { format } from "date-fns";
import { getCellWidthInPercent } from "features/admin/clients/ClientsTable";
import useAccessGroups from "features/admin/access-groups/useAccessGroups";

const columns = [
    {
        headCellProps: {
            text: "Access Group",
            width: "76.22%",
        },

        getBodyCellProps: (cell) => ({
            text: cell.value,
            placement: "bottom-start",
            tooltip: cell.row.original.description
                ? `${cell.row.original.description}`
                : "",
            actionIcon: "caret-right",
            actionProps: {
                to: `${cell.row.original.id}`,
            },
        }),
        accessor: "name",
    },
    {
        headCellProps: {
            text: "Members",
            width: "9.15%",
        },
        getBodyCellProps: (cell) => ({
            text: cell.value,
        }),
        accessor: "membersCount",
    },
    {
        headCellProps: {
            text: "Date Added",
            width: "12.2%",
        },
        getBodyCellProps: (cell) => ({
            text: format(new Date(cell.value), "MMM dd, yyyy"),
        }),
        accessor: "createDate",
    },
    {
        headCellProps: {
            width: getCellWidthInPercent(80),
        },
        accessor: "edit",
        disableSortBy: true,
        getBodyCellProps: (cell) => ({
            shownByRowHover: true,
            actionIcon: "edit",
            actionProps: {
                to: `?action=edit&id=${cell.row.original.id}`,
                replace: true,
                "aria-label": "Edit Access Group",
            },
        }),
    },
];

const getRowProps = (row) => ({
    style: {
        background: row.values.Active === false ? COLOR_VALUES.Gray_9 : "",
    },
});

const AccessGroupTable = ({ onSearchClick }) => {
    const { accessGroups } = useAccessGroups();
    const sortBy = [
        {
            id: "name",
            asc: true,
        },
    ];

    const tableContent = accessGroups.error ? (
        <>Error</>
    ) : (
        <VStack>
            <HStack justify="flex-end" spacing="One">
                {onSearchClick && (
                    <TertiaryButton
                        aria-label="Search"
                        leadingIcon="search"
                        onClick={onSearchClick}
                    />
                )}
                <SecondaryButton
                    mediumSmall
                    leadingIcon="expand"
                    label="Add Access Group"
                    to="?action=add"
                    replace={true}
                />
            </HStack>
            <Table
                showTableBorder={false}
                columns={columns}
                data={accessGroups.data}
                getRowProps={getRowProps}
                sortBy={sortBy}
            />
        </VStack>
    );

    return (
        <>
            {accessGroups.isLoading ? <>Loading...</> : tableContent}
        </>
    );
};

AccessGroupTable.propTypes = {
    onSearchClick: PropTypes.func,
};

export default React.memo(AccessGroupTable);
